import IntroPage from './IntroPage'

export default IntroPage
